import { render, staticRenderFns } from "./idolOnSaleGoodsOrderList.vue?vue&type=template&id=c96d4280&scoped=true"
import script from "./idolOnSaleGoodsOrderList.vue?vue&type=script&lang=ts"
export * from "./idolOnSaleGoodsOrderList.vue?vue&type=script&lang=ts"
import style0 from "./idolOnSaleGoodsOrderList.vue?vue&type=style&index=0&id=c96d4280&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d4280",
  null
  
)

export default component.exports